import {
  Button,
  handleGoHome,
  PageBody,
  Result,
  Stack,
} from '@pypestream/design-system';
import { FC } from 'react';

interface ErrorPageProps {
  label: string;
  body: string;
}

export const ErrorPage: FC<ErrorPageProps> = ({ label, body }) => {
  return (
    <PageBody background="none">
      <Result align="center" status="error" label={label} body={body}>
        <Stack gutter="xsmall" justifyContent="center" slot="footer">
          <Button
            size="large"
            onClick={() => handleGoHome({ accountId: undefined })}
          >
            Go back home
          </Button>
        </Stack>
      </Result>
    </PageBody>
  );
};
